import { render } from "./MiNTNewsTest.vue?vue&type=template&id=5eb205d0&scoped=true"
import script from "./MiNTNewsTest.vue?vue&type=script&lang=js"
export * from "./MiNTNewsTest.vue?vue&type=script&lang=js"

import "./MiNTNewsTest.vue?vue&type=style&index=0&id=5eb205d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb205d0"]])

export default __exports__